import React from 'react';
import PropTypes from 'prop-types';
import { iconsList } from '../../../../../icon/glyphs';
import Icon from '../../../../../icon';
import { TYPES } from '../../../../../icon/constants';

const TreeViewItemIcon = ({
  iconGlyph,
  customIconGlyph = null,
  hoverIconGlyph,
  iconType = TYPES.default,
  disabled = false,
}) => (
  <div className="ws-ui-tree-view-item-icon">
    <span className="ws-ui-tree-view-item-icon__default">
      {customIconGlyph || (
        <Icon glyph={iconGlyph} type={disabled ? TYPES.inherit : iconType} size="100%" />
      )}
    </span>
    <span className="ws-ui-tree-view-item-icon__hover">
      <Icon glyph={hoverIconGlyph} type={iconType} size="100%" />
    </span>
  </div>
);

TreeViewItemIcon.propTypes = {
  iconGlyph: PropTypes.oneOf(iconsList).isRequired,
  customIconGlyph: PropTypes.node,
  hoverIconGlyph: PropTypes.oneOf(iconsList).isRequired,
  iconType: PropTypes.oneOf(Object.values(TYPES)),
  disabled: PropTypes.bool,
};

export default TreeViewItemIcon;
